import { useLocation } from 'react-router-dom'
import Routes from '../../data/routes'
import useConfirmationActions from '../../data/useConfirmationActions'

import { useHeaderMeQuery } from '../../graphql'
import getPhoenixUrlParams from '../../lib/get-phoenix-url-params'
import useCheckoutContext from '../../data/useCheckoutContext'
import HeaderComponent from './HeaderComponent'

const Header = () => {
  const { data, error } = useHeaderMeQuery()
  const { goBackToWebsite, goToMyProfile } = useConfirmationActions()

  const location = useLocation()
  const isConfirmationPage = location.pathname === Routes.CONFIRMATION
  const { hideEversportsBranding } = getPhoenixUrlParams(location.search)
  const { isVenueBrandingEnabled } = useCheckoutContext()

  if (error) {
    throw new Error(error.message)
  }

  const username = data?.me?.firstName
  const avatar = data?.me?.profilePicture?.xSmall

  // For now, the branding removal is just on the confirmation page.
  // Later we will debrand the whole checkout (but needs a larger discovery + design)
  if (isConfirmationPage) {
    return (
      <HeaderComponent
        username={username}
        avatar={avatar}
        goBackToWebsite={goBackToWebsite}
        goToMyProfile={goToMyProfile}
        hideEversportsBranding={isVenueBrandingEnabled || hideEversportsBranding}
      />
    )
  }

  return <HeaderComponent username={username} avatar={avatar} />
}

export default Header
